import type { ReactElement } from 'react';
import { useAuth } from 'components/management/NewAuthProvider';
import NoAccessAppBar from '../Appbar/NoAccessAppbar';
import Home from 'components/Home/Home';
import Footer from '../Footer';
import { useApplication } from 'ApplicationContext';
import { hasAccessToAnyApp } from 'accessGuards';

const MainNoAccess = (): ReactElement => {
  const { user, error, isAdmin } = useAuth();
  const { app } = useApplication();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <NoAccessAppBar showLogin={!user} />
      <div style={{ flex: 1 }}>
        <Home loggedInNoAccess={(!!user && !hasAccessToAnyApp({ groups: user.groups, isAdmin, app })) || !!error} />
      </div>
      <Footer />
    </div>
  );
};

export default MainNoAccess;
